import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { BulletinService } from 'src/app/services/bulletin/bulletin.service';

@Component({
  selector: 'app-bulletin',
  templateUrl: './bulletin.component.html',
  styleUrls: ['./bulletin.component.scss'],
})
export class BulletinComponent implements OnInit, OnDestroy {
  bulletin: string = 'Admissions Open for Academic Session 2026-27. Enquire Now…';
  sub: Subscription;

  constructor(private bulletinService: BulletinService) {}

  ngOnInit(): void {
    this.bulletinService.getBulletin();
    this.sub = this.bulletinService.bulletinList.snapshotChanges().subscribe((list) => {
      const items = list.map(item => {
        const val = item.payload.val();
        return typeof val === 'string' ? val : (val.text || val.message || '');
      });
      if (items.length > 0) {
        this.bulletin = items.filter(text => text.trim().length > 0).join(' | ');
      }
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
